export default function hamburger() {
  const header = document.querySelector('.header');
  const hamburgerMenu = document.getElementById('switch-menu');
  const headerMenu = header?.querySelector('.header__menu');
  const menuBody = header?.querySelector('.header__menu--body');
  const textOpen = hamburgerMenu?.querySelector('.screen-reader-text.open');
  const textClose = hamburgerMenu?.querySelector('.screen-reader-text.close');

  if (!hamburgerMenu || !header || !headerMenu) {
    return null;
  }

  // Menu switch state
  let switchOn = false;

  // Open/close menu on click
  hamburgerMenu.addEventListener('click', () => {
    switchOn ? close() : open();
  });

  // Close menu on click outside
  document.addEventListener('click', (event) => {
    if (
      switchOn &&
      event.target.classList.contains('header__menu')
    ) {
      close();
    }
  });

  // Close menu on click inside .header__menu--body
  // menuBody?.addEventListener('click', () => {
  //   if (switchOn) {
  //     close();
  //   }
  // });

  // Close menu on link's click
  headerMenu
    ?.querySelectorAll('.wp-block-navigation-item__content')
    ?.forEach((item) => {
      item.addEventListener('click', () => {
        close();
      });
    });

  // Update menu height on window resize and close menu if open
  const throttledUpdateHeaderMenuHeight = throttle(updateHeaderMenuHeight, 300);

  window.addEventListener('resize', () => {
    throttledUpdateHeaderMenuHeight();
    if (switchOn) {
      close();
    }
  });

  // === Menu Close/Open functions ===
  function close() {
    hamburgerMenu?.classList.remove('open');
    headerMenu?.classList.remove('open');
    header?.classList.remove('has-menu-open');
    document.body?.classList.remove('prevent-scroll');
    textOpen?.classList.add('active');
    textClose?.classList.remove('active');
    switchOn = false;
  }

  function open() {
    hamburgerMenu.classList.add('open');
    headerMenu?.classList.add('open');
    header?.classList.add('has-menu-open');
    document.body?.classList.add('prevent-scroll');
    textOpen?.classList.remove('active');
    textClose?.classList.add('active');
    switchOn = true;
  }

  function updateHeaderMenuHeight() {
    const headerMenuHeight = window.innerHeight - header?.offsetHeight;
    if (!headerMenuHeight) {
      return;
    }

    document.documentElement.style.setProperty(
      '--header-menu-height',
      `${headerMenuHeight}px`,
    );
  }

  // Initial menu height
  updateHeaderMenuHeight();

  return { close, open };
}

/**
 * Throttle function - limits the rate at which a function can fire
 * @param {Function} fn   - The function to throttle
 * @param {number}   time - The time to throttle the function
 * @return {Function} - The throttled function
 */
export function throttle(fn, time) {
  let timeout = null;
  return function () {
    if (timeout) return;
    const context = this;
    const args = arguments;
    const later = () => {
      fn.call(context, ...args);
      timeout = null;
    };
    timeout = setTimeout(later, time);
  };
}
